import Board from '../board/Board';
import Banner from './banner/Banner';
import Title from './title/Title';
import TotalBonus from './totalBonus/TotalBonus';
import TotalFriends from './totalFriends/TotalFriends';
import Settings from '../../../../settings/Settings';

const MASK = {
    WIDTH: 671,
    HEIGHT: 470,
};

const TWEEN = {
    DURATION: 250,
    EASE: {
        SHOW: Phaser.Math.Easing.Back.Out,
        HIDE: Phaser.Math.Easing.Back.In,
    },
};

export default class Body extends Phaser.GameObjects.Container {
    private board: Board | null = null;
    private bg!: Phaser.GameObjects.Image;
    private close!: Phaser.GameObjects.Image;
    private title!: Title;
    private banner!: Banner;
    private disclaimer!: Phaser.GameObjects.BitmapText;

    // Optional
    private shape!: Phaser.GameObjects.Image;
    private totalBonus!: TotalBonus;
    private totalFriends!: TotalFriends;
    private panelRanking!: Phaser.GameObjects.Image;
    private invite!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupBG();
        this.setupTitle();
        this.setupClose();
        this.setupBanner();
        // this.setupTotalBonus();
        this.setupInvite();
        this.setupTotalFriends();
        this.setupPanelRanking();
        this.setupMask();
        this.showBoard();
        // this.setupDisclaimer();

        this.setScale(0);
    }

    static get MASK() {
        return MASK;
    }

    setupBG() {
        let frame = 'gui/common/popup_bg';

        this.bg = this.scene.add.image(0, 0, 'atlas', frame);
        this.add(this.bg);
    }

    setupTitle() {
        let x = 0;
        let y = -486;

        this.title = new Title(this.scene, x, y);
        this.add(this.title);
    }

    setupClose() {
        let x = 270;
        let y = -482;
        let frame = 'icons/close';

        this.close = this.scene.add.image(x, y, 'atlas', frame);
        this.add(this.close);

        this.close.setInteractive({ useHandCursor: true });
        this.close.on('pointerdown', () => this.emit('close'));
    }

    setupBanner() {
        let x = 0;
        let y = -410;

        this.banner = new Banner(this.scene, x, y);
        this.add(this.banner);
    }

    setupDisclaimer() {
        let x = 0;
        let y = -610;

        const LABEL = {
            FONT: Settings.FONTS.LXGW_CYRILLIC_BOLD,
            SIZE: 70,
            TINT: 0x000000,
        };

        this.disclaimer = this.scene.add.bitmapText(0, 0, LABEL.FONT, this.scene.cache.json.get('i18n')['friends_section_coming_soon'], LABEL.SIZE);
        this.disclaimer.setOrigin(0.5);
        this.disclaimer.setTint(LABEL.TINT);
        this.add(this.disclaimer);
    }

    setupTotalBonus() {
        let x = 0;
        let y = -200;

        this.totalBonus = new TotalBonus(this.scene, x, y, {});
        this.add(this.totalBonus);
    }

    createInviteLink() {
        const telegramId: string | undefined = window.Telegram.WebApp?.initDataUnsafe?.user?.id;
        if (!telegramId) return "";

        const queryString = 'referral=' + telegramId;
        return btoa(queryString).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    }

    setupInvite() {
        let x = 0;
        let y = 460;
        let frame = 'gui/friends/button_invite_friend';

        this.invite = this.scene.add.image(x, y, 'atlas', frame);
        this.invite.setInteractive();

        this.invite.on('pointerup', () => {
            const encodedData = this.createInviteLink();
            const inviteLink = `https://t.me/AliceBobGame_bot/play?startapp=${encodedData}`;

            window.Telegram.WebApp.openTelegramLink(
                `https://t.me/share/url?url=${inviteLink}`
            );
        }, this);

        this.add(this.invite);
        this.bringToTop(this.invite);

        const icon = this.scene.add.image(x - 100, y, 'atlas', 'gui/friends/Invite_friend icon');
        icon.setOrigin(0.5);
        this.add(icon);

        const label = this.scene.add.text(x + 20, y, this.scene.cache.json.get('i18n')['invite_friends'], {
            fontFamily: 'Arial',
            fontSize: '22px',
            fontStyle: 'bold',
            color: '#ffffff',
            stroke: '#000000',
            strokeThickness: 4,
            align: 'center',
        });
        label.setOrigin(0.5);
        this.add(label);
    }


    setupTotalFriends() {
        let x = -300;
        // let y = -5;
        let y = -200;

        this.totalFriends = new TotalFriends(this.scene, x, y);
        this.add(this.totalFriends);
    }

    setupPanelRanking() {
        let x = 0;
        let y = -125;
        let frame = 'gui/common/panel_ranking';

        this.panelRanking = this.scene.add.image(x, y, 'atlas', frame);
        this.panelRanking.setDisplaySize(600, 30);
        this.add(this.panelRanking);

        const leftText = this.scene.add.text(x - 270, y, this.scene.cache.json.get('i18n')['name'], {
            fontFamily: 'Arial',
            fontSize: '16px',
            fontStyle: 'bold',
            color: '#7182A5',
            align: 'left',
        });
        leftText.setOrigin(0, 0.5);
        this.add(leftText);

        const rightText = this.scene.add.text(x + 270, y, this.scene.cache.json.get('i18n')['reward'], {
            fontFamily: 'Arial',
            fontSize: '16px',
            fontStyle: 'bold',
            color: '#7182A5',
            align: 'right',
        });
        rightText.setOrigin(1, 0.5);
        this.add(rightText);
    }


    setupMask() {
        let x = this.scene.cameras.main.centerX;
        let y = this.scene.cameras.main.centerY - 100;

        this.shape = this.scene.add.image(x, y, 'atlas', 'blank');
        this.shape.setOrigin(0.5, 0);
        this.shape.setDisplaySize(671, 495);
        this.shape.setVisible(false);
    }

    showBoard() {
        let x = 0;
        let y = -15;

        this.board = new Board(this.scene, x, y);
        this.add(this.board);

        this.board.mask = this.shape.createBitmapMask();
    }

    show(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 1,
                scaleY: 1,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE.SHOW,
                onComplete: () => resolve(),
            });
        });
    }

    hide(): Promise<void> {
        return new Promise((resolve) => {
            this.scene.tweens.add({
                targets: this,
                scaleX: 0,
                scaleY: 0,
                duration: TWEEN.DURATION,
                ease: TWEEN.EASE.HIDE,
                onComplete: () => resolve(),
            });
        });
    }

    destroy() {
        // this.shape.destroy();
        super.destroy();
    }
}
